import { useBlogCardWebContext } from "./BlogCardWebProvider";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { Typography } from "@mui/material";

export const BlogCardWebDescription = () => {
  const { state } = useBlogCardWebContext();
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  return (
    <Typography
      sx={{
        color: colors.surface.onSurfaceVariant,
        marginTop: "0.5rem",
      }}
    >
      {state.blog.description.length > 150
        ? state.blog.description.slice(0, 150) + "..."
        : state.blog.description}
    </Typography>
  );
};
